import { Box, Skeleton } from '@mui/material';

import UserContacts from '../UserContacts';
import PaymentMethod from '../PaymentMethod';
import usePriceConfig from '../../../../../shared/features/priceConfig/hooks/usePriceConfig';
import rootStore from '../../../rootStore/RootStore';

export default function UserDetails() {
  const { isLoaded } = usePriceConfig(rootStore);

  return (
    <Box
      sx={(theme) => ({
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
        px: 4,
        py: 3,
        border: `1px solid ${theme.palette.grey[100]}`,
        borderRadius: 4,
        backgroundColor: theme.palette.common.white,
      })}
    >
      {isLoaded ? (
        <UserContacts />
      ) : (
        <Skeleton variant="rounded" height={340} />
      )}
      <PaymentMethod />
    </Box>
  );
}
